import { PlacePredictionViewModel } from "Services/API/API";
import usePlaceGeocoder from "Services/Geocoder";
import { useEffect, useState } from "react";

function usePlacesAutocomplete(allowInternational = false) {
   const [isLoading, setIsLoading] = useState(false);
   const [query, setQuery] = useState<string | null | undefined>(null);
   const [options, setOptions] = useState<PlacePredictionViewModel[]>([]);
   const geocoder = usePlaceGeocoder();

   useEffect(() => {
      const abortController = new AbortController();

      if (query?.trim()) {
         setIsLoading(true);         
         geocoder.getPlacePredictions({
            input: query,
            allowInternational
         }).then(result => {
            setOptions(result ?? []);
            setIsLoading(false);
         });         
      }
      else {
         setOptions([]);
      }

      return function cleanup() {
         abortController.abort();
      }
   }, [query]);

   return {
      isLoading: isLoading,
      options: options,     
      handleSearch: setQuery
   }
}

export default usePlacesAutocomplete;